/**
 * CertificateManagementGuard
 *
 * Ensures routes related to certificate management are accessible only to users
 * who are authenticated and whose company has the certificate management
 * feature enabled. If the user is authenticated but the company's
 * `isCertificateManagementEnabled` flag is not true, the guard redirects
 * the user to the NotFound route. Otherwise the guard renders the
 * `ProtectedGuard` to enforce authentication and render the children.
 */
import { Navigate } from 'react-router';

import { useAuth } from '../hooks/auth/useAuth';
import { AppRoutes } from '../shared/enums/app-routes';
import ProtectedGuard from './ProtectedGuard';

type CertificateManagementGuardProps = {
  children: React.ReactNode;
};

const CertificateManagementGuard = ({ children }: CertificateManagementGuardProps) => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user?.company?.isCertificateManagementEnabled !== true) {
    return <Navigate to={AppRoutes.NotFound} replace={true} />;
  }

  return <ProtectedGuard>{children}</ProtectedGuard>;
};

export default CertificateManagementGuard;
